<template>
  <span
    v-if="params?.value"
    class="material-icons-outlined atb-align-middle"
    :title="getTitle"
    :style="{
      color: lock_icon_color,
      cursor: getLockStatus === 'AUTO_LOCKED' ? 'default' : 'pointer',
    }"
    @click="clickHandler"
  >
    {{ lock_icon }}</span
  >
</template>

<script lang="ts">
  import { defineComponent, toRefs, PropType, computed } from 'vue';
  import LockStatus from '@/app/shared/enums/lock-status.enum';
  import { LockCellProps } from '@/app/shared/types/grid-cells/lock-cell-props.interface';
  import { VersionControl } from '@/app/shared/types/version-control.interface';

  export default defineComponent({
    name: 'LockCell',
    props: {
      params: {
        type: Object as PropType<LockCellProps>,
        required: false,
      },
    },
    setup(props) {
      const { params } = toRefs(props);
      const isAutoLock = false;

      const LOCKED_COLOR = '#E7C022';
      const UNLOCKED_COLOR = '#28B463';
      const AUTO_LOCK_COLOR = '#D22B2B';
      const autoLockedByUserId = computed(() => {
        const val = params.value?.value
          .filter((vc: VersionControl) => vc.dataSource == null)
          .shift();
        return val?.autoLockedByUserId;
      });

      const lockedByUserId = computed(() => {
        const val = params.value?.value
          .filter((vc: VersionControl) => vc.dataSource == null)
          .shift();
        return val?.lockedByUserId;
      });

      const lockedByUsername = computed(() => {
        const val = params.value?.value
          .filter((vc: VersionControl) => vc.dataSource == null)
          .shift();
        return val?.lockedByUsername;
      });

      const getLockStatus = computed(() => {
        let status;
        getAutoLockStatus.value
          ? (status = LockStatus.AUTO_LOCKED)
          : autoLockedByUserId.value
          ? (status = LockStatus.LOCKED)
          : lockedByUserId.value
          ? (status = LockStatus.MANUAL_LOCKED)
          : (status = LockStatus.UNLOCKED);
        return status;
      });

      const lock_icon = computed(() =>
        lockedByUsername.value ? 'lock' : 'lock_open'
      );

      const lock_icon_color = computed(() => {
        let lock_icon_color = '';
        lock_icon_color =
          getLockStatus.value === LockStatus.AUTO_LOCKED
            ? AUTO_LOCK_COLOR
            : getLockStatus.value === LockStatus.MANUAL_LOCKED ||
              getLockStatus.value === LockStatus.LOCKED
            ? LOCKED_COLOR
            : UNLOCKED_COLOR;
        return lock_icon_color;
      });

      const getAutoLockStatus = computed(() => {
        return params.value?.getAutoLockStatusById(params.value?.data?.id);
      });

      const getTitle = computed(() =>
        lockedByUsername.value
          ? `Locked by ${lockedByUsername.value}`
          : 'Click to Lock'
      );

      const clickHandler = () => {
        if (getLockStatus.value !== LockStatus.AUTO_LOCKED) {
          const { id } = params.value?.data;
          getLockStatus.value === LockStatus.UNLOCKED
            ? params.value?.lock(id, isAutoLock)
            : params.value?.unlock(id, isAutoLock);
        }
      };

      return {
        lock_icon,
        lock_icon_color,
        getLockStatus,
        getTitle,
        clickHandler,
      };
    },
  });
</script>
